import { localeMap } from "@hooks/useDatePickerLocale";
import { format } from "date-fns";
import i18n from "@/i18n";

export default (date, dateStr, options = {}) => {
  const locale = localeMap[i18n.language ?? "en"];
  return format(date, dateStr, { locale, ...options });
};
